export default __webpack_public_path__ + "static/media/95_desktop.7b85848d.jpg";